import React from "react";
import ESIInclude from "@JohnLewisPartnership/jl-esi-components";
import esiSourceWrapper from "../../constants/esiSourceWrapper";
import styles from "./DecisionTree.module.scss";

function SolutionESI({ esiSource }) {
  return (
    <div className={styles.solutionContainer}>
      <div className={styles.solutionESIContainer}>
        <ESIInclude src={esiSourceWrapper(esiSource)} id="content" />
      </div>
    </div>
  );
}

export default SolutionESI;
